var exports = {
  "text": "x24da60e8--436227--text",
  "level-1": "x24da60e8--436227--level-1",
  "normal": "x24da60e8--436227--normal",
  "bold": "x24da60e8--436227--bold",
  "primary": "x24da60e8--436227--primary",
  "current-color": "x24da60e8--436227--current-color",
};

module.exports = exports;
